import { render, staticRenderFns } from "./TabsLayout.vue?vue&type=template&id=c110648c&scoped=true&"
import script from "./TabsLayout.vue?vue&type=script&lang=js&"
export * from "./TabsLayout.vue?vue&type=script&lang=js&"
import style0 from "./TabsLayout.vue?vue&type=style&index=0&id=c110648c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c110648c",
  null
  
)

export default component.exports